import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type PartDimensionsDto = ClientInferRequest<typeof contract.parts.updateDimensions>["body"];

type PartDimensionsResponse = ClientInferResponseBody<typeof contract.parts.updateDimensions, 200>;

export const updatePartDimensions = async (
  id: string,
  payload: PartDimensionsDto,
): Promise<PartDimensionsResponse> => {
  const response = await api.parts.updateDimensions.mutation({
    params: {
      id,
    },
    body: {
      ...payload,
    },
  });

  if (response.status !== 200) {
    throw new ApiError(
      "Erreur lors de la mise à jour des dimensions de la pièce",
      response.status,
      response.body,
    );
  }

  return response.body;
};
